
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, curry2, stringHash, comparePrimitives, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { partition, tryHead, tail, toArray as toArray_1, contains as contains_1, forAll, length, empty, singleton, append, cons, collect as collect_1, isEmpty, choose, exists, filter, sortWith, map, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { empty as empty_2, singleton as singleton_1, append as append_1, delay, toList, iterate } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { unwrap, defaultArg, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Operators_IsNull } from "../../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Label_$reflection } from "../../Shared/Category.js";
import { string_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { sortAsc } from "../../SharedComponents/NaturalOrder.js";
import { useTranslation } from "react-i18next";
import { FSharpSet__Add, FSharpSet__Remove, FSharpSet__Contains, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { FSharpMap__TryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { List_distinct, Array_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { append as append_2, contains, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { LabelId__get_unwrap } from "../../Shared/Shared.js";
import { IconChevronRight } from "../../Components/Icon.js";
import { Badge } from "../../Components/Badge.js";
import { ReactPopover } from "../../Components/ReactPopover.js";
import { IconInput } from "../../Components/Input.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { TextButton } from "../../Components/Button.js";

export function Element$(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["font-medium"])], (elems = [Checkbox({
        ComponentState: "enabled",
        IsChecked: props.Checked,
        Label: props.Label,
        OnCheck: props.OnCheck,
        TestId: concat("table-select-filter-", props.Id, ..."-checkbox"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function SelectAllCheckbox(props) {
    let elems;
    const inputRef = reactApi.useRef(undefined);
    const isIndeterminate = props.SomeSelected && !props.AllSelected;
    const dependencies = [isIndeterminate];
    reactApi.useEffect(() => {
        iterate((el) => {
            el.indeterminate = isIndeterminate;
        }, toArray(inputRef.current));
    }, dependencies);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "pb-2", "mb-2", "border-b", "border-gray-200"])], (elems = [reactElement("input", {
        ref: (el_1) => {
            if (!Operators_IsNull(el_1)) {
                inputRef.current = el_1;
            }
        },
        className: join(" ", ["cursor-pointer", "w-4", "h-4", "text-blue-600", "bg-white", "border-[#808080]", "border-2", "rounded-sm", "accent-primary"]),
        type: "checkbox",
        checked: props.AllSelected,
        onChange: (ev) => {
            const _arg = ev.target.checked;
            props.OnToggle();
        },
    }), reactElement("label", {
        className: join(" ", ["ml-2", "text-sm", "font-semibold", "cursor-pointer", "text-gray-700", "select-none"]),
        children: props.Label,
        onClick: (_arg_1) => {
            props.OnToggle();
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export class CategoryTreeNode extends Record {
    constructor(Label, Children) {
        super();
        this.Label = Label;
        this.Children = Children;
    }
}

export function CategoryTreeNode_$reflection() {
    return record_type("Widgets.Table.SelectFilter.CategoryTreeNode", [], CategoryTreeNode, () => [["Label", Label_$reflection()], ["Children", list_type(CategoryTreeNode_$reflection())]]);
}

export function buildCategoryTree(allLabels) {
    const buildChildren = (parentId) => map((label_1) => (new CategoryTreeNode(label_1, buildChildren(label_1.Id))), sortWith((label1, label2) => (sortAsc(label1.Name, label2.Name) | 0), filter((label) => equals(label.ParentLabelId, parentId), allLabels)));
    return map((label_3) => (new CategoryTreeNode(label_3, buildChildren(label_3.Id))), sortWith((label1_1, label2_1) => (sortAsc(label1_1.Name, label2_1.Name) | 0), filter((label_2) => {
        const matchValue = label_2.ParentLabelId;
        if (matchValue != null) {
            const parentId_1 = matchValue;
            return !exists((other) => equals(other.Id, parentId_1), allLabels);
        }
        else {
            return true;
        }
    }, allLabels)));
}

export function filterCategoryTree(search, nodes) {
    return choose((node) => {
        if (node.Label.Name.toLocaleLowerCase().indexOf(search) >= 0) {
            return node;
        }
        else {
            const matchValue = filterCategoryTree(search, node.Children);
            if (isEmpty(matchValue)) {
                return undefined;
            }
            else {
                return new CategoryTreeNode(node.Label, matchValue);
            }
        }
    }, nodes);
}

export function flattenCategoryTree(nodes) {
    return collect_1((node) => cons(node, flattenCategoryTree(node.Children)), nodes);
}

export function collectCategoryPathNames(nodes) {
    const collect = (prefix, nodes_1) => collect_1((node) => {
        const path = append(prefix, singleton(node.Label.Name));
        return cons([join(" > ", path), node.Label.Name], collect(path, node.Children));
    }, nodes_1);
    return collect(empty(), nodes);
}

export function CategorySelectFilter(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const searchValue = patternInput_1[0];
    let patternInput_2;
    const initial_1 = empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    patternInput_2 = reactApi.useState(initial_1);
    const setCollapsedIds = patternInput_2[1];
    const collapsedIds = patternInput_2[0];
    const nodes = buildCategoryTree(props.Labels);
    const nameByPathName = ofList(collectCategoryPathNames(nodes), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    const selectedValues = Array_distinct(map_1((value) => defaultArg(FSharpMap__TryFind(nameByPathName, value), value), defaultArg(props.SelectedValues, [])), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: (x_2) => (stringHash(x_2) | 0),
    });
    const visibleNodes = (searchValue === "") ? nodes : filterCategoryTree(searchValue.toLocaleLowerCase(), nodes);
    const allNames = toList(delay(() => append_1(map((node) => node.Label.Name, flattenCategoryTree(nodes)), delay(() => (props.HasEmptyOption ? singleton_1("__empty__") : empty_2())))));
    const visibleNames = toList(delay(() => append_1(map((node_1) => node_1.Label.Name, flattenCategoryTree(visibleNodes)), delay(() => ((props.HasEmptyOption && (searchValue === "")) ? singleton_1("__empty__") : empty_2())))));
    const numberOfSelectedItems = length(filter((name) => contains(name, selectedValues, {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: (x_3) => (stringHash(x_3) | 0),
    }), allNames)) | 0;
    const allVisibleSelected = !isEmpty(visibleNames) && forAll((name_1) => contains(name_1, selectedValues, {
        Equals: (x_4, y_4) => (x_4 === y_4),
        GetHashCode: (x_4) => (stringHash(x_4) | 0),
    }), visibleNames);
    const someSelected = exists((name_2) => contains(name_2, selectedValues, {
        Equals: (x_5, y_5) => (x_5 === y_5),
        GetHashCode: (x_5) => (stringHash(x_5) | 0),
    }), visibleNames);
    const toggleName = (name_3, isChecked) => {
        if (isChecked) {
            props.OnFilterChange(Array_distinct(append_2(selectedValues, [name_3]), {
                Equals: (x_6, y_6) => (x_6 === y_6),
                GetHashCode: (x_6) => (stringHash(x_6) | 0),
            }));
        }
        else {
            props.OnFilterChange(selectedValues.filter((value_2) => (value_2 !== name_3)));
        }
    };
    const renderNodes = (depth, nodes_1) => collect_1((node_2) => {
        const idString = LabelId__get_unwrap(node_2.Label.Id);
        const hasChildren = !isEmpty(node_2.Children);
        const isExpanded = (searchValue !== "") ? true : !FSharpSet__Contains(collapsedIds, idString);
        return toList(delay(() => {
            let elems_3;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "py-1"])], ["style", {
                paddingLeft: (depth * 24) + "px",
            }], (elems_3 = toList(delay(() => {
                let elems;
                return append_1(hasChildren ? singleton_1(reactElement("button", createObj(ofArray([["className", join(" ", toList(delay(() => append_1(singleton_1("w-4"), delay(() => append_1(singleton_1("h-4"), delay(() => append_1(singleton_1("flex"), delay(() => append_1(singleton_1("items-center"), delay(() => append_1(singleton_1("justify-center"), delay(() => append_1(singleton_1("cursor-pointer"), delay(() => append_1(singleton_1("text-gray-500"), delay(() => (isExpanded ? singleton_1("rotate-90") : empty_2()))))))))))))))))))], ["onClick", (_arg) => {
                    if (FSharpSet__Contains(collapsedIds, idString)) {
                        setCollapsedIds(FSharpSet__Remove(collapsedIds, idString));
                    }
                    else {
                        setCollapsedIds(FSharpSet__Add(collapsedIds, idString));
                    }
                }], (elems = [IconChevronRight(16)], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("div", {
                    className: join(" ", ["w-4", "shrink-0"]),
                })), delay(() => {
                    let elems_1;
                    return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => (hasChildren ? singleton_1("font-semibold") : singleton_1("font-medium")))))], (elems_1 = [Checkbox({
                        ComponentState: "enabled",
                        IsChecked: contains(node_2.Label.Name, selectedValues, {
                            Equals: (x_9, y_9) => (x_9 === y_9),
                            GetHashCode: (x_9) => (stringHash(x_9) | 0),
                        }),
                        Label: node_2.Label.Name,
                        OnCheck: curry2(toggleName)(node_2.Label.Name),
                        TestId: concat("table-category-filter-", idString, ..."-checkbox"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let elems_2;
                        return hasChildren ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-auto", "pl-2"])], (elems_2 = [createElement(Badge, {
                            Color: "#F3F4F6",
                            Label: int32ToString(length(node_2.Children)),
                            TestId: concat("table-category-filter-", idString, ..."-badge"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_2();
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => ((hasChildren && isExpanded) ? renderNodes(depth + 1, node_2.Children) : empty_2())));
        }));
    }, nodes_1);
    return createElement(ReactPopover, {
        Body: (_arg_1) => {
            let elems_9, elems_4, elems_5, arg_1, elems_8, elems_10;
            return ofArray([reactElement("div", createObj(ofArray([["className", join(" ", ["px-6", "py-3", "min-w-max", "max-h-[20rem]", "overflow-auto"])], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [createElement(IconInput, {
                ComponentState: "enabled",
                LeftIcon: Magnifying_Glass(),
                OnChange: patternInput_1[1],
                TestId: concat("table-popover-", props.TestId, ..."-search-value-input"),
                Value: searchValue,
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems_5 = [createElement(SelectAllCheckbox, {
                AllSelected: allVisibleSelected,
                Label: t("table.select_all"),
                OnToggle: () => {
                    if (allVisibleSelected) {
                        props.OnFilterChange(selectedValues.filter((value_3) => !contains_1(value_3, visibleNames, {
                            Equals: (x_7, y_7) => (x_7 === y_7),
                            GetHashCode: (x_7) => (stringHash(x_7) | 0),
                        })));
                    }
                    else {
                        props.OnFilterChange(Array_distinct(append_2(selectedValues, toArray_1(visibleNames)), {
                            Equals: (x_8, y_8) => (x_8 === y_8),
                            GetHashCode: (x_8) => (stringHash(x_8) | 0),
                        }));
                    }
                },
                SomeSelected: someSelected,
            }), reactElement("div", {
                className: join(" ", ["flex-1", "flex", "justify-end", "items-center", "pl-6", "pb-2", "mb-2", "border-b", "border-gray-200", "text-sm", "text-gray-500", "whitespace-nowrap"]),
                children: (arg_1 = {
                    selected: numberOfSelectedItems,
                    total: length(allNames),
                }, patternInput[1].t("table.selected_count", arg_1)),
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["max-h-[5rem]", "h-sm:max-h-[8rem]", "h-md:max-h-[16rem]", "h-lg:max-h-[30rem]", "overflow-auto"])], (elems_8 = toList(delay(() => {
                let elems_7, elems_6, IsChecked_1, OnCheck_1;
                return append_1((props.HasEmptyOption && (searchValue === "")) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "py-1"])], (elems_7 = [reactElement("div", {
                    className: join(" ", ["w-4", "shrink-0"]),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["font-medium"])], (elems_6 = [Checkbox((IsChecked_1 = contains("__empty__", selectedValues, {
                    Equals: (x_10, y_10) => (x_10 === y_10),
                    GetHashCode: (x_10) => (stringHash(x_10) | 0),
                }), (OnCheck_1 = curry2(toggleName)("__empty__"), {
                    ComponentState: "enabled",
                    IsChecked: IsChecked_1,
                    Label: t("table.filter_empty_option"),
                    OnCheck: OnCheck_1,
                    TestId: "table-category-filter-empty-checkbox",
                })))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty_2(), delay(() => renderNodes(0, visibleNodes)));
            })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "font-semibold", "pb-2", "min-w-max", "p-2"])], (elems_10 = [createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("table.reset_filter"),
                OnClick: () => {
                    props.OnFilterChange([]);
                },
                TestId: "table-reset-filter",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))]);
        },
        ButtonBadge: unwrap((numberOfSelectedItems === 0) ? undefined : int32ToString(numberOfSelectedItems)),
        ButtonLabel: props.ButtonLabel,
        ComponentState: "enabled",
        TestId: concat("table-popover-", ...props.TestId),
    });
}

export class LocationTreeNode extends Record {
    constructor(Path, Name, Children) {
        super();
        this.Path = Path;
        this.Name = Name;
        this.Children = Children;
    }
}

export function LocationTreeNode_$reflection() {
    return record_type("Widgets.Table.SelectFilter.LocationTreeNode", [], LocationTreeNode, () => [["Path", string_type], ["Name", string_type], ["Children", list_type(LocationTreeNode_$reflection())]]);
}

export function buildLocationTree(paths) {
    const build = (prefix, segmentLists_1) => map((name) => {
        const path_1 = append(prefix, singleton(name));
        return new LocationTreeNode(join(" > ", path_1), name, build(path_1, filter((arg) => !isEmpty(arg), map(tail, filter((segments) => equals(tryHead(segments), name), segmentLists_1)))));
    }, sortWith((a, b) => (sortAsc(a, b) | 0), List_distinct(choose(tryHead, segmentLists_1), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    })));
    return build(empty(), map((path) => ofArray(split(path, [" > "], undefined, 0)), List_distinct(paths, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
}

export function filterLocationTree(search, nodes) {
    return choose((node) => {
        if (node.Name.toLocaleLowerCase().indexOf(search) >= 0) {
            return node;
        }
        else {
            const matchValue = filterLocationTree(search, node.Children);
            if (isEmpty(matchValue)) {
                return undefined;
            }
            else {
                return new LocationTreeNode(node.Path, node.Name, matchValue);
            }
        }
    }, nodes);
}

export function flattenLocationTree(nodes) {
    return collect_1((node) => cons(node, flattenLocationTree(node.Children)), nodes);
}

export function LocationSelectFilter(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const searchValue = patternInput_1[0];
    let patternInput_2;
    const initial_1 = empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    patternInput_2 = reactApi.useState(initial_1);
    const setCollapsedPaths = patternInput_2[1];
    const collapsedPaths = patternInput_2[0];
    const nodes = buildLocationTree(props.Paths);
    const visibleNodes = (searchValue === "") ? nodes : filterLocationTree(searchValue.toLocaleLowerCase(), nodes);
    const allValues = toList(delay(() => append_1(map((_arg) => _arg.Path, flattenLocationTree(nodes)), delay(() => (props.HasEmptyOption ? singleton_1("__empty__") : empty_2())))));
    const visibleValues = toList(delay(() => append_1(map((_arg_1) => _arg_1.Path, flattenLocationTree(visibleNodes)), delay(() => ((props.HasEmptyOption && (searchValue === "")) ? singleton_1("__empty__") : empty_2())))));
    const isSelected = (value) => contains(value, props.SelectedValues, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    });
    const numberOfSelectedItems = length(filter(isSelected, allValues)) | 0;
    const allVisibleSelected = !isEmpty(visibleValues) && forAll(isSelected, visibleValues);
    const someSelected = exists(isSelected, visibleValues);
    const toggleValue = (value_1, isChecked) => {
        if (isChecked) {
            props.OnFilterChange(Array_distinct(append_2(props.SelectedValues, [value_1]), {
                Equals: (x_2, y_2) => (x_2 === y_2),
                GetHashCode: (x_2) => (stringHash(x_2) | 0),
            }));
        }
        else {
            props.OnFilterChange(props.SelectedValues.filter((selectedValue) => (selectedValue !== value_1)));
        }
    };
    const renderNodes = (depth, nodes_1) => collect_1((node) => {
        const hasChildren = !isEmpty(node.Children);
        const isExpanded = (searchValue !== "") ? true : !FSharpSet__Contains(collapsedPaths, node.Path);
        return toList(delay(() => {
            let elems_3;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "py-1"])], ["style", {
                paddingLeft: (depth * 24) + "px",
            }], (elems_3 = toList(delay(() => {
                let elems;
                return append_1(hasChildren ? singleton_1(reactElement("button", createObj(ofArray([["data-test-id", concat("table-location-filter-", node.Path, ..."-toggle")], ["className", join(" ", toList(delay(() => append_1(singleton_1("w-4"), delay(() => append_1(singleton_1("h-4"), delay(() => append_1(singleton_1("flex"), delay(() => append_1(singleton_1("items-center"), delay(() => append_1(singleton_1("justify-center"), delay(() => append_1(singleton_1("cursor-pointer"), delay(() => append_1(singleton_1("text-gray-500"), delay(() => (isExpanded ? singleton_1("rotate-90") : empty_2()))))))))))))))))))], ["onClick", (_arg_2) => {
                    if (FSharpSet__Contains(collapsedPaths, node.Path)) {
                        setCollapsedPaths(FSharpSet__Remove(collapsedPaths, node.Path));
                    }
                    else {
                        setCollapsedPaths(FSharpSet__Add(collapsedPaths, node.Path));
                    }
                }], (elems = [IconChevronRight(16)], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("div", {
                    className: join(" ", ["w-4", "shrink-0"]),
                })), delay(() => {
                    let elems_1;
                    return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => (hasChildren ? singleton_1("font-semibold") : singleton_1("font-medium")))))], (elems_1 = [Checkbox({
                        ComponentState: "enabled",
                        IsChecked: isSelected(node.Path),
                        Label: node.Name,
                        OnCheck: curry2(toggleValue)(node.Path),
                        TestId: concat("table-location-filter-", node.Path, ..."-checkbox"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let elems_2;
                        return hasChildren ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-auto", "pl-2"])], (elems_2 = [createElement(Badge, {
                            Color: "#F3F4F6",
                            Label: int32ToString(length(node.Children)),
                            TestId: concat("table-location-filter-", node.Path, ..."-badge"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_2();
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => ((hasChildren && isExpanded) ? renderNodes(depth + 1, node.Children) : empty_2())));
        }));
    }, nodes_1);
    return createElement(ReactPopover, {
        Body: (_arg_3) => {
            let elems_10, elems_4, elems_5, elems_6, arg_1, elems_9, elems_11;
            return ofArray([reactElement("div", createObj(ofArray([["className", join(" ", ["px-6", "py-3", "min-w-max", "max-h-[20rem]", "overflow-auto"])], (elems_10 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [createElement(IconInput, {
                ComponentState: "enabled",
                LeftIcon: Magnifying_Glass(),
                OnChange: patternInput_1[1],
                TestId: concat("table-popover-", props.TestId, ..."-search-value-input"),
                Value: searchValue,
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["pb-2", "mb-2", "border-b", "border-gray-200", "font-medium"])], (elems_5 = [Checkbox({
                ComponentState: "enabled",
                IsChecked: props.IncludeSubLocations,
                Label: t("table.include_sub_locations"),
                OnCheck: props.OnIncludeSubLocationsChange,
                TestId: concat("table-select-filter-", props.TestId, ..."-include-sub-locations"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems_6 = [createElement(SelectAllCheckbox, {
                AllSelected: allVisibleSelected,
                Label: t("table.select_all"),
                OnToggle: () => {
                    if (allVisibleSelected) {
                        props.OnFilterChange(props.SelectedValues.filter((value_2) => !contains_1(value_2, visibleValues, {
                            Equals: (x_3, y_3) => (x_3 === y_3),
                            GetHashCode: (x_3) => (stringHash(x_3) | 0),
                        })));
                    }
                    else {
                        props.OnFilterChange(Array_distinct(append_2(props.SelectedValues, toArray_1(visibleValues)), {
                            Equals: (x_4, y_4) => (x_4 === y_4),
                            GetHashCode: (x_4) => (stringHash(x_4) | 0),
                        }));
                    }
                },
                SomeSelected: someSelected,
            }), reactElement("div", {
                className: join(" ", ["flex-1", "flex", "justify-end", "items-center", "pl-6", "pb-2", "mb-2", "border-b", "border-gray-200", "text-sm", "text-gray-500", "whitespace-nowrap"]),
                children: (arg_1 = {
                    selected: numberOfSelectedItems,
                    total: length(allValues),
                }, patternInput[1].t("table.selected_count", arg_1)),
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["max-h-[5rem]", "h-sm:max-h-[8rem]", "h-md:max-h-[16rem]", "h-lg:max-h-[30rem]", "overflow-auto"])], (elems_9 = toList(delay(() => {
                let elems_8, elems_7, IsChecked_2, OnCheck_2;
                return append_1((props.HasEmptyOption && (searchValue === "")) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "py-1"])], (elems_8 = [reactElement("div", {
                    className: join(" ", ["w-4", "shrink-0"]),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["font-medium"])], (elems_7 = [Checkbox((IsChecked_2 = isSelected("__empty__"), (OnCheck_2 = curry2(toggleValue)("__empty__"), {
                    ComponentState: "enabled",
                    IsChecked: IsChecked_2,
                    Label: t("table.filter_empty_option"),
                    OnCheck: OnCheck_2,
                    TestId: "table-location-filter-empty-checkbox",
                })))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty_2(), delay(() => renderNodes(0, visibleNodes)));
            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "font-semibold", "pb-2", "min-w-max", "p-2"])], (elems_11 = [createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("table.reset_filter"),
                OnClick: () => {
                    props.OnFilterChange([]);
                },
                TestId: "table-reset-filter",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))]);
        },
        ButtonBadge: unwrap((numberOfSelectedItems === 0) ? undefined : int32ToString(numberOfSelectedItems)),
        ButtonLabel: props.ButtonLabel,
        ComponentState: "enabled",
        TestId: concat("table-popover-", ...props.TestId),
    });
}

export function SelectFilter(props) {
    const t = useTranslation()[0];
    const numberOfSelectedItems = length(filter((item) => item.Checked, props.Items)) | 0;
    const visibleItems = filter((item_1) => (item_1.Id !== ""), props.Items);
    const patternInput_1 = partition((item_2) => (item_2.Id === "__empty__"), visibleItems);
    const allSelected = !isEmpty(visibleItems) && forAll((item_3) => item_3.Checked, visibleItems);
    const someSelected = exists((item_4) => item_4.Checked, visibleItems);
    return createElement(ReactPopover, {
        Body: (_arg) => {
            let elems_2, elems_3;
            return ofArray([reactElement("div", createObj(ofArray([["className", join(" ", ["px-6", "py-3", "min-w-max", "max-h-[20rem]", "overflow-auto"])], (elems_2 = toList(delay(() => {
                let elems;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(IconInput, {
                    ComponentState: "enabled",
                    LeftIcon: Magnifying_Glass(),
                    OnChange: props.OnSearch,
                    TestId: concat("table-popover-", props.TestId, ..."-search-value-input"),
                    Value: props.SearchValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(!isEmpty(visibleItems) ? singleton_1(createElement(SelectAllCheckbox, {
                    AllSelected: allSelected,
                    Label: t("table.select_all"),
                    OnToggle: () => {
                        if (allSelected) {
                            props.OnDeselectAll();
                        }
                        else {
                            props.OnSelectAll(map((item_5) => item_5.Id, visibleItems));
                        }
                    },
                    SomeSelected: someSelected,
                })) : empty_2(), delay(() => {
                    let elems_1;
                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["max-h-[5rem]", "h-sm:max-h-[8rem]", "h-md:max-h-[16rem]", "h-lg:max-h-[30rem]", "overflow-auto"])], (elems_1 = toList(delay(() => map((item_6) => createElement(Element$, {
                        Checked: item_6.Checked,
                        Id: item_6.Id,
                        Label: item_6.Label,
                        OnCheck: item_6.OnCheck,
                    }), append(patternInput_1[0], sortWith((item1, item2) => (sortAsc(item1.Id, item2.Id) | 0), patternInput_1[1]))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "font-semibold", "pb-2", "min-w-max", "p-2"])], (elems_3 = [createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("table.reset_filter"),
                OnClick: props.OnResetFilter,
                TestId: "table-reset-filter",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))]);
        },
        ButtonBadge: unwrap((numberOfSelectedItems === 0) ? undefined : int32ToString(numberOfSelectedItems)),
        ButtonLabel: props.ButtonLabel,
        ComponentState: props.ComponentState,
        TestId: concat("table-popover-", ...props.TestId),
    });
}

